import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Copy, Check, AlertCircle } from 'lucide-react'
import { useEmailDrafterStore } from '@/stores/email-drafter'
import { useState, useEffect } from 'react'

export function ResponseViewer() {
  const { response, error } = useEmailDrafterStore()
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 2000)
      return () => clearTimeout(timer)
    }
  }, [copied])

  const handleCopy = () => {
    if (response) {
      // Create a temporary element to get text from HTML
      const temp = document.createElement('div')
      temp.innerHTML = response
      const text = temp.textContent || temp.innerText || ''

      navigator.clipboard.writeText(text)
      setCopied(true)
    }
  }

  const handleCopyHTML = () => {
    if (response) {
      navigator.clipboard.writeText(response)
      setCopied(true)
    }
  }

  if (!response && !error) {
    return null
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Antwort</CardTitle>
        {response && (
          <div className="flex gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleCopy}
            >
              {copied ? (
                <Check className="h-4 w-4 mr-1" />
              ) : (
                <Copy className="h-4 w-4 mr-1" />
              )}
              Text kopieren
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={handleCopyHTML}
            >
              {copied ? (
                <Check className="h-4 w-4 mr-1" />
              ) : (
                <Copy className="h-4 w-4 mr-1" />
              )}
              HTML kopieren
            </Button>
          </div>
        )}
      </CardHeader>
      <CardContent>
        {error && (
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        {response && (
          <div className="space-y-4">
            <div className="text-sm text-muted-foreground">
              Empfangen: {new Date().toLocaleString('de-DE')}
            </div>
            <div
              className="prose prose-sm dark:prose-invert max-w-none rounded-lg border p-4 bg-muted/30"
              dangerouslySetInnerHTML={{ __html: response }}
            />
          </div>
        )}
      </CardContent>
    </Card>
  )
}